import NavigationBar from "@/components/NavigationBar";
import { ContactForm } from "@/components/ContactForm";

const Contact = () => {
  return (
    <div className="min-h-screen bg-gradient-background">
      <NavigationBar />
      
      <div className="container mx-auto px-4 py-20">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-6xl font-bold bg-gradient-hero bg-clip-text text-transparent mb-4">
              Contact Us
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
              Questions about EventDatePicker? Need help with your events? We're here to help!
            </p>
          </div>
          
          <ContactForm />
        </div>
      </div>
    </div>
  );
};

export default Contact;